import { useState } from "react";
import "../../../styles/studio/folder/studioFolderEntries.css";
import StudioFolderListView from "./StudioFolderListView.jsx";
import StudioFolderGridView from "./StudioFolderGridView.jsx";

/**
 * Handles rendering of folder entries in list or grid view
 * Supports drag-and-drop reordering and global loading blocking
 */
const StudioFolderEntries = ({
  entries = [],
  viewMode = "grid",
  loading = false,
  currentFolderPath = [],
  globalLoading = false,
  setGlobalLoading,
  fetchData,
  isReordering = false,
  setLocalEntries,
  setHasChanges,
  setError,
}) => {
  const [hoveredIndex, setHoveredIndex] = useState(null);

  /* ================= LOADING ================= */
  if (loading) {
    return (
      <div className="studio-folder-entries-section">
        <div className="studio-folder-entries-loading">
          {[...Array(6)].map((_, idx) => (
            <div key={idx} className="studio-folder-entry-skeleton" />
          ))}
        </div>
      </div>
    );
  }

  /* ================= EMPTY ================= */
  if (!entries || entries.length === 0) {
    return (
      <div className="studio-folder-entries-section studio-folder-empty">
        <p>No items inside this folder.</p>
      </div>
    );
  }

  /* ================= DRAG UPDATE HANDLER ================= */
  const handleReorder = (newEntries) => {
    setLocalEntries(newEntries);
    setHasChanges(true);
  };

  /* ================= VIEW RENDER ================= */
  return (
    <div className="studio-folder-entries-section">
      {viewMode === "list" ? (
        <StudioFolderListView
          entries={entries}
          setEntries={handleReorder}
          hoveredIndex={hoveredIndex}
          setHoveredIndex={setHoveredIndex}
          currentFolderPath={currentFolderPath}
          globalLoading={globalLoading}
          setGlobalLoading={setGlobalLoading}
          fetchData={fetchData}
          isReorderMode={isReordering}
          setError={setError}
        />
      ) : (
        <StudioFolderGridView
          entries={entries}
          setEntries={handleReorder}
          currentFolderPath={currentFolderPath}
          globalLoading={globalLoading}
          setGlobalLoading={setGlobalLoading}
          fetchData={fetchData}
          isReorderMode={isReordering}
          setError={setError}
        />
      )}
    </div>
  );
};

export default StudioFolderEntries;
